// `call` with `ask` — the question before another wizard opens. "No" routes as
// the `cancelled` outcome.

import { ArrowRightLeft } from 'lucide-react'
import { text } from '../model'
import { button, card } from '../styles'
import { tw } from '../../testHooks'
import type { StepProps } from './common'

export default function CallStep({ ctl, handheld }: StepProps) {
  const { step, scope, busy } = ctl
  if (!step || !scope) return null
  return (
    <div style={{ ...card, display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start', fontSize: handheld ? 17 : 15, lineHeight: 1.45 }}>
        <ArrowRightLeft size={20} style={{ flexShrink: 0, marginTop: 2 }} />
        <span>{text(step.ask, scope)}</span>
      </div>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <button type="button" style={{ ...button(handheld, true, !!busy), flex: handheld ? 1 : undefined }}
          disabled={!!busy} onClick={() => void ctl.answerCall(true)} {...tw('action', 'call_yes')}>Yes</button>
        <button type="button" style={{ ...button(handheld, false, !!busy), flex: handheld ? 1 : undefined }}
          disabled={!!busy} onClick={() => void ctl.answerCall(false)} {...tw('action', 'call_no')}>No</button>
      </div>
    </div>
  )
}
